var app = angular.module('leonardo');

var Config = {
  baseURL: window.LEO_BASE_URL,
  baseURLMedia: window.LEO_BASE_URL_MEDIA,
  version: window.LEO_VERSION,
  environment: window.LEO_ENVIRONMENT,
  debug: window.LEO_DEBUG,
  envoyAdminURL: window.LEO_ENVOY_ADMIN_URL,

  generateURL: function (path) {
    return this.baseURL + path;
  },

  generateURLMedia: function (path) {
    return this.baseURLMedia + path;
  },

  generateURI: function (path) {
    return new URI(this.baseURL + path);
  }
};

app.constant('Config', Config);
